<mat-sidenav-container cdkscrollable #sidenavContainer>
  <mat-sidenav class="header-sidenav" #sidenav role="navigation">
    <!-- Because WCAG, we need to have 2 app-header -->
    <app-header></app-header>
    <app-side-nav></app-side-nav>
  </mat-sidenav>

  <mat-sidenav-content>
    <!-- We have this div for scroll to top component -->
    <h1 class="visually-hidden" id="top-div">
      {{ 'HEADER.LOGO_CUSTOMER_PORTAL_TEXT' | translate }}
    </h1>
    <!-- Because WCAG, we need to have 2 app-header -->
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <!-- scroll to top -->
    <div #scrollToRef class="scroll-to-top">
      <button
        matIconButton
        type="button"
        class="btn active"
        data-toggle="button"
        aria-pressed="true"
        (click)="onScrollToTop()">
        <span class="material-symbols-outlined"> arrow_upward </span>
      </button>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Idle -->
<app-idle></app-idle>
